import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wot7i5g",
  propsAsIs: false
});
const LeftWrapper = /*#__PURE__*/styled('div')({
  name: "LeftWrapper",
  class: "lvots9j",
  propsAsIs: false
});
const RightWrapper = /*#__PURE__*/styled('div')({
  name: "RightWrapper",
  class: "r9esrp0",
  propsAsIs: false
});
const RightInnerWrapper = /*#__PURE__*/styled('div')({
  name: "RightInnerWrapper",
  class: "rtfbwz5",
  propsAsIs: false
});
export const CompactDefaultLayout: React.FC<OfferLayoutBaseProps | OfferLayoutLoadingProps> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  ctaComponent,
  roomLabelsComponent,
  tagComponent,
  dataId,
  cashbackComponent
}) => {
  if (isLoading) return <Wrapper data-id="loader">
        <div>
          <SkeletonLoader width={90} height={20} marginTop={4} />
        </div>
        <div>
          <SkeletonLoader width={130} height={42} marginTop={4} align="right" />
        </div>
      </Wrapper>;
  return <Wrapper data-id={dataId}>
      <LeftWrapper>
        {tagComponent}
        {providerLogoComponent}
        {roomLabelsComponent}
      </LeftWrapper>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {cashbackComponent}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>;
};

require("./CompactDefaultLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CompactDefaultLayout.tsx");